export const DEFAULT_FEED_URL = 'https://grafana.com/blog/news.xml';
